import Vue from 'vue';

import * as Sentry from '@sentry/browser';

import App from './App.vue';
import router from './router';
import axios from './axios';
import store from './store';

Vue.config.productionTip = false;

axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    // Do something with response error
    if (error.request.status === 401) {
      const redirect = router.history.current.fullPath;
      store.commit('logout');

      if (redirect.indexOf('?redirect') < 0) {
        Vue.nextTick(() => router.push({ path: '/login', query: { redirect } }));
      }
    }

    return Promise.reject(error);
  }
);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

Sentry.init({
  dsn: 'https://8e364df696814fb8ab9fe1ca6b0e8b90@sentry.io/1380910',
  integrations: [new Sentry.Integrations.Vue({ Vue })]
});
